// ============================================================
// ConfirmDialog.js
// Yes/no confirmation, used for destructive actions: revoke
// invitation, revoke entitlement, deactivate user, disable
// module for client.
//
// Built on the shared <Modal> wrapper (which itself wraps the
// native <dialog>). Confirm button is destructive-styled by
// default; pass `tone="primary"` for non-destructive confirms.
// ============================================================

import React from 'react';
import { Loader2 } from 'lucide-react';
import Modal from './Modal';
import './ConfirmDialog.css';

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel  = 'Cancel',
  tone         = 'danger',
  isSubmitting = false,
}) {
  const confirmClass = tone === 'danger'
    ? 'confirm-dialog__confirm confirm-dialog__confirm--danger'
    : 'confirm-dialog__confirm confirm-dialog__confirm--primary';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} closeDisabled={isSubmitting}>
      <div className="confirm-dialog">
        {typeof message === 'string'
          ? <p className="confirm-dialog__message">{message}</p>
          : <div className="confirm-dialog__message">{message}</div>}
        <div className="confirm-dialog__actions">
          <button
            type="button"
            className="confirm-dialog__cancel"
            onClick={onClose}
            disabled={isSubmitting}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={confirmClass}
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting && <Loader2 size={14} className="confirm-dialog__spinner" />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
